import React from "react";

import xboxLogo from "../../assets/images/xbox-logo.png";

import * as styles from "./XboxSpinner.module.css";

const defaultSize = 38;

type XboxSpinnerProps = Readonly<{
  size?: number;
}>;

export const XboxSpinner = ({ size }: XboxSpinnerProps) => (
  <span className={styles.spinner}>
    <img
      aria-live="assertive"
      role="alert"
      alt="Xbox"
      className={styles.logo}
      draggable={false}
      src={xboxLogo}
      tabIndex={-1}
      width={size ?? defaultSize}
      height={size ?? defaultSize}
    />
  </span>
);
